import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './AuthProvider';

export function RequireAuth({ children }) {
  const { isAuthenticated, isLoading, signinRedirect } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Every full page load (including just typing a URL) wipes the in-memory
      // session and lands here, so this fires far more often than "the user
      // wasn't logged in" — it's the normal path for any direct navigation.
      // Without passing the originally-requested path through as state, the
      // post-login callback has no way to know where to send the user back to.
      signinRedirect({ state: { returnTo: location.pathname + location.search } });
    }
  }, [isLoading, isAuthenticated, signinRedirect, location]);

  if (isLoading || !isAuthenticated) {
    // isLoading: still checking for an existing Cognito session.
    // !isAuthenticated (not loading): signinRedirect() above is about to
    // navigate away — show the spinner during that brief window too,
    // rather than a blank flash.
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
}
